import React from 'react'
import moment from 'moment'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

// helpers
import { convertMoney } from '../../../helpers/format-number'

const AppDetails = ({
  assetDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Asset name"
          subtitle={assetDetails?.name}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Asset value"
          subtitle={`IDR ${convertMoney(assetDetails?.value)}`}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Asset register date"
          subtitle={moment(assetDetails?.register_date).format('DD/MM/YYYY')}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Cash?"
          subtitle={assetDetails?.is_cash ? 'Yes' : 'No'}
        />
      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="4"
          title="Asset description"
          subtitle={assetDetails?.description}
        />
      </CRow>
    </>
  )
}

export default AppDetails
